import React, { CSSProperties } from 'react';

export interface AppAvatarProps {
  src?: string;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  circle?: boolean;
  className?: string;
  style?: CSSProperties;
  pulsingBorderColor?: 'primary' | 'success' | 'warning' | 'danger';
  pulsingBorder?: boolean;
  topLeftIcon?: React.ReactNode;
  onClick?: () => void;
}

// Map abstract size names to pixel dimensions
const sizeMap: Record<NonNullable<AppAvatarProps['size']>, number> = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 64,
  xxl: 96,
};

const AppAvatar: React.FC<AppAvatarProps> = ({
  src,
  alt = 'avatar',
  size = 'md',
  circle = true,
  className = '',
  style,
  pulsingBorder = false,
  pulsingBorderColor = 'primary',
  topLeftIcon,
  onClick,
}) => {
  const dimension = sizeMap[size] || sizeMap.md;
  const borderClass = pulsingBorder ? `pulsing-border ${pulsingBorderColor}` : '';
  const radius = circle ? '50%' : '8px';

  return (
    <div className="position-relative d-inline-block" style={{ lineHeight: 0 }} onClick={onClick} role={onClick ? 'button' : undefined}>
      <img
        src={src}
        alt={alt}
        width={dimension}
        height={dimension}
        className={`${className} ${borderClass}`.trim()}
        style={{
          objectFit: 'cover',
            width: dimension,
            height: dimension,
            borderRadius: radius,
            display: 'inline-block',
            ...style,
        }}
        loading="lazy"
      />
      {topLeftIcon && (
        <div
          className="position-absolute top-0 start-0"
          style={{ transform: 'translate(-25%, -25%)', zIndex: 10 }}
        >
          {topLeftIcon}
        </div>
      )}
    </div>
  );
};

export default AppAvatar;
